// extracted by mini-css-extract-plugin
export default {"container":"n1-z","list":"o1-z"};